import { render, staticRenderFns } from "./facturas_ventas_dia.vue?vue&type=template&id=4e01cbb4&"
import script from "./facturas_ventas_dia.vue?vue&type=script&lang=js&"
export * from "./facturas_ventas_dia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports